import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from './Button';

export function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div className="update-prompt" role="status">
      <div>
        <strong>新版本已准备好</strong>
        <p>请在战斗空闲时更新，页面不会自动刷新。</p>
      </div>
      <Button onClick={() => setNeedRefresh(false)}>稍后</Button>
      <Button tone="primary" onClick={() => void updateServiceWorker(true)}>
        立即更新
      </Button>
    </div>
  );
}
